import { LuMenu } from "react-icons/lu";
import {
  useIsSideMenuOpen,
  useSideMenuActions,
} from "../../view_stores/useSideMenuStore";

export function SideMenuIcon() {
  const { open: openSideMenu, close: closeSideMenu } = useSideMenuActions();
  const isSideMenuOpen = useIsSideMenuOpen();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (isSideMenuOpen) {
      closeSideMenu();
    } else {
      openSideMenu();
    }
  };

  return (
    <button
      onClick={handleClick}
      className="p-1 -m-1 cursor-pointer text-dark-text
        hover:opacity-80 transition-opacity"
      aria-label="Toggle menu"
    >
      <LuMenu size={34} />
    </button>
  );
}
